//
//
//
//
//
//
//

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    styles: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    pressButton() {
      if (!this.disabled && !this.loading) {
        this.$emit('press');
      }
    },
    getStyle() {
      const base = [
        'dib fw7 br-pill submit-button flex justify-center tc',
        this.styles || 'bg-purple white',
      ];
      if (this.disabled) {
        base.push('bg-light-silver');
      } else {
        base.push('pointer');
      }
      return base.join(' ');
    },
  },
};
